// Types & Interfaces
import { ISalesLeadErrors, IPhone, TCustomerType } from "@/DataPages/context/crm/interfaces";
import { TType, TSelectValue, TYesNoOption, TDesiredVehicleSearchField } from "../types";

// Constants
import { INTERNET_TYPE } from "@/DataPages/context/crm/LeadsContext/constants";

const TABS: Array<{ key: keyof ISalesLeadErrors; label: string }> = [
	{ key: "customer", label: "Customer Information" },
	{ key: "prospect", label: "Prospect Information" },
	{ key: "vehicle", label: "Desired Vehicle" },
];

const PROSPECT_INFORMATION_TAB: Record<string, TType[]> = {
	categories: [{ type: "Sales" }, { type: "Service" }, { type: "Parts" }],
	types: [{ type: INTERNET_TYPE }, { type: "Phone" }, { type: "Other" }, { type: "List" }],
	statuses: [{ type: "HOT" }, { type: "New from F&I" }, { type: "Sold - Integration" }, { type: "New" }, { type: "Duplicate" }],
	statusType: [{ type: "Open" }, { type: "Closed" }, { type: "Sold" }],
};

const DESIRED_VEHICLE_TAB: Record<string, TType[]> = {
	stockTypes: [{ type: "New" }, { type: "Used" }, { type: "CPO" }],
};

const REQUIRED_FIELD_CLASSES = "!shadow-thin-red-line !bg-light-error";

const TYPE_OF_PHONES = [
	{ type: "Home Phone" },
	{ type: "Business Phone" },
	{ type: "Cell Phone" },
	{ type: "Fax Phone" },
	{ type: "Pager Number" },
];

const PREFERRED_CONTACT_METHODS: Array<TSelectValue> = [
	{ text: "Email", value: "Email", consent: ["email"] },
	{ text: "Text", value: "Text", consent: ["text"] },
	{ text: "Pager", value: "Pager", consent: ["text"] },
	{ text: "Cell", value: "Cell", consent: ["phone"] },
	{ text: "Fax", value: "Fax", consent: ["phone"] },
	{ text: "Home", value: "Home", consent: ["phone"] },
	{ text: "Work", value: "Work", consent: ["phone"] },
	{ text: "Direct Mail", value: "Direct Mail", consent: ["use"] },
	{ text: "Other", value: "Other" },
	{ text: "Unlisted", value: "Unlisted" },
];

const SEND_TEXTS_TO: Array<TSelectValue> = [
	{ text: "Home Phone", value: "H" },
	{ text: "Business Phone", value: "B" },
	{ text: "Cell Phone", value: "C" },
	{ text: "Fax Number", value: "F" },
	{ text: "Pager Number", value: "P" },
	{ text: "Unlisted Number", value: "U" },
	{ text: "Other Number", value: "O" },
];

const YES_NO_OPTIONS: Array<TYesNoOption> = [
	{ name: "Yes", value: "Y" },
	{ name: "No", value: "N" },
] as const;

const CONSENTS_MAPPING = {
	emailConsent: { label: "Email Consent" },
	textConsent: { label: "Text Consent" },
	phoneConsent: { label: "Phone Consent" },
	sharePersonalInfoConsent: { label: "Share Personal Info" },
	usePersonalInfoConsent: { label: "Use Personal Info" },
};

const EMPTY_PHONE_NUMBER: IPhone = { id: "", number: "", type: "" };

const CUSTOMER_TYPES: Array<TCustomerType> = ["individual", "business"];

const MAX_DESIRED_VEHICLE = 4;
const DISABLED_MULTIPLE_SELECTION = true;

const INITIAL_STATE_SEARCH_DESIRED_VEHICLE: TDesiredVehicleSearchField = {
	type: "",
	stockNumber: "",
	vin: "",
	make: "",
	model: "",
	style: "",
	year: "",
};

export {
	TABS,
	PROSPECT_INFORMATION_TAB,
	DESIRED_VEHICLE_TAB,
	INTERNET_TYPE,
	REQUIRED_FIELD_CLASSES,
	TYPE_OF_PHONES,
	EMPTY_PHONE_NUMBER,
	PREFERRED_CONTACT_METHODS,
	SEND_TEXTS_TO,
	YES_NO_OPTIONS,
	CONSENTS_MAPPING,
	CUSTOMER_TYPES,
	MAX_DESIRED_VEHICLE,
	DISABLED_MULTIPLE_SELECTION,
	INITIAL_STATE_SEARCH_DESIRED_VEHICLE,
};
